<div class="form-radio" [class.error]="isInvalid" [class.disabled]="controlConfig.disabled">
  <fieldset [formGroup]="formGroup">
    <legend>{{ controlConfig.label }} <span *ngIf="controlConfig.required">*</span></legend>

    <div class="radio-options">
      @for (option of controlConfig.options; track option.value; let i = $index) {
        <div class="radio-option">
          <label [id]="'label-' + getRadioId(i)" [for]="getRadioId(i)" [class.disabled]="controlConfig.disabled || option.disabled">
            <input
              type="radio"
              [id]="getRadioId(i)"
              [attr.name]="controlConfig.name"
              [formControlName]="controlConfig.name"
              [value]="option.value"
              [required]="controlConfig.required"
              [attr.aria-invalid]="isInvalid"
              [attr.aria-describedby]="errorId + ' ' + 'success-message-' + controlConfig.name"
              [attr.disabled]="controlConfig.disabled || option.disabled" />
            <span class="label-text">{{ option.label }}</span>
          </label>
        </div>
      }
    </div>
  </fieldset>

  <div [id]="errorId" aria-live="assertive">
    <span class="error-message" *ngIf="errorMessage">
      <span class="sr-only">Fehler</span>
      {{ errorMessage }}
    </span>
  </div>

  <div [id]="'success-message-' + controlConfig.name" aria-live="assertive">
    <span class="sr-only" *ngIf="isValid">Eingabe gültig</span>
  </div>
</div>
